import {
  FDBodyText, FDBox, FDIcon, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

// TODO DVH this is very similar to using an FDListItem with an icon, text, and right-aligned text but
// the amount of padding that our FDListItem comes with makes this view break and look bad on mobile with
// label or amount values that are even a little bit long. We should consider if we need to allow the padding/
// spacing on FDListItem to be adjustable or if this should just stay a one-off
export const BreakdownAmountRow = ({ icon, label, amount }) => {
  return (
    <FDStack spacing={1} alignItems={'center'}>
      <FDIcon icon={icon} />
      <FDBox flex={1}>
        <FDBodyText value={label} />
      </FDBox>
      <FDBodyText value={amount} />
    </FDStack>
  );
};

BreakdownAmountRow.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
};
